import React from 'react';
import { Typography, Card, Steps, Button } from 'antd';
import { YoutubeOutlined, ArrowRightOutlined } from '@ant-design/icons';
import './bienvenida.css';

const { Title, Paragraph } = Typography;

const Bienvenida = () => {
    const videoUrl = '/video/girlPower/welcome.mp4';

    return (
        <div className="bienvenida-container mobile-block">
            <div className="hero-section">
                <Title level={2} className="welcome-title">¡Bienvenida a la Familia Girl Power! 💖</Title>
                <Paragraph className="welcome-subtitle">
                    Estamos muy felices de tenerte aquí. Tu camino hacia una mejor versión empieza hoy.
                </Paragraph>
            </div>

            <Card className="video-card premium-shadow">
                <div className="video-wrapper">
                    <video 
                        controls 
                        autoPlay 
                        muted 
                        loop={false}
                        className="welcome-video"
                    >
                        <source src={videoUrl} type="video/mp4" />
                        Tu navegador no soporta el formato de video.
                    </video>
                </div>
            </Card>

            <div className="path-section">
                <Title level={4}>Tu Ruta de Inicio</Title>
                <Steps
                    direction="vertical"
                    current={0}
                    items={[
                        {
                            title: 'Mira el video de bienvenida',
                            description: 'Conoce un poco más sobre nuestra comunidad.',
                            icon: <YoutubeOutlined />,
                        },
                        {
                            title: 'Próximamente más interacciones',
                            description: 'Estamos preparando sorpresas para ti.',
                            disabled: true,
                        },
                    ]}
                />
            </div>

            <div className="footer-actions">
                <Button type="button" className='btn themed-btn' icon={<ArrowRightOutlined />} href="/home">
                    Ir a mi Dashboard
                </Button>
            </div>
        </div>
    );
};

export default Bienvenida;
